<template>
  <div class="adminPickingReadingSixten">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ picking }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ reading }}</router-link>
      </li>
    </ol>
    <div class="container-fluid">
      <div class="card">
        <div class="card-header" v-if="barcodeReaderData == ''">
          <div class="row">
            <div class="col">{{ reading }}</div>
          </div>
        </div>
        <div class="card-body" style="padding: 1.25rem" v-if="barcodeReaderData == ''">
          <div id="dManualInput" v-if="manualInput">
            <form id="frmBarcodeReader" @submit.prevent="submitBarcode" action="#">
              <div class="row">
                <div class="col-sm-12 col-lg-6">
                  <input
                    type="text"
                    name="txtBarcodeReader"
                    ref="txtBarcodeReader"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-sm-12 col-lg-1">
                  <button class="btn btn-success btn-block" type="submit">
                    <i class="fa fa-floppy-o"></i>
                    {{ read }}
                  </button>
                </div>
                <div class="col-sm-12 col-lg-5">
                  <button
                    class="btn btn-primary btn-block"
                    @click="clickEnableScanner"
                    type="button"
                  >
                    <i class="fa fa-barcode"></i>
                    {{ enableScanner }}
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div id="scannerInput" v-if="!manualInput">
            <div class="row">
              <div class="col">
                <barcodeReader :value.sync="barcodeReaderData"></barcodeReader>
              </div>
            </div>
            <div class="row">
              <div class="col text-right">
                <button class="btn btn-success btn-block" @click="clickDisableScanner">
                  <i class="fa fa-barcode"></i>
                  {{ disableScanner }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="card-header" v-if="barcodeReaderData != ''">
          <div class="row">
            <div class="col text-right">
              <h6>
                {{ order }}:
                <b>{{ documentCode }}</b>
              </h6>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h4>
                {{ item }}:
                <b>{{ item_code }}</b>
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h6>{{ item_description }}</h6>
            </div>
          </div>
        </div>
        <div class="card-body" style="padding: 1.25rem" v-if="barcodeReaderData != ''">
          <form id="frmAdminPickingReading">
            <div class="row">
              <div class="col-6">{{ label_order_quantity }}</div>
              <div class="col-6">{{ order_quantity }}</div>
            </div>
            <div class="row">
              <div class="col">
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-6">{{ label_order_picking }}</div>
              <div class="col-6">
                <input
                  type="text"
                  @change="changeOrderPicking"
                  class="form-control"
                  id="txtOrderPicking"
                  v-model="txtOrderPicking"
                  style="width:100%"
                  required
                />
                <input type="hidden" v-model="hOrderPicking" />
              </div>
            </div>
            <div class="row">
              <div class="col">
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="col-6">{{ label_package }}</div>
              <div class="col-6 col-lg-4">
                <select2
                  id="sPackage"
                  :default="packageDataDefault"
                  class="form-control"
                  minimumInputLength="1"
                  :options="packageData"
                  service="packageByErp"
                  required
                  style="width:100%"
                ></select2>
              </div>
              <div class="col-sm-12 col-lg-2 text-right">
                <button
                  class="btn btn-primary btn-sm"
                  type="button"
                  @click="executeConfirmAddPackage"
                >
                  <i class="fa fa-plus"></i>
                  {{addPackage}}
                </button>
              </div>
            </div>
            <div class="row">&nbsp;</div>
            <div class="row">
              <div class="col text-right">
                <button
                  type="button"
                  class="btn btn-block btn-danger"
                  @click="executeConfirmCancel"
                >
                  <i class="fa fa-times"></i>
                  <span>{{ cancel }}</span>
                </button>
                <button type="button" class="btn btn-block btn-success" @click="executeSave">
                  <i class="fa fa-floppy-o"></i>
                  <span>{{ save }}</span>
                </button>
                <!-- <button
                  type="button"
                  class="btn btn-block btn-primary"
                  @click="executeConfirmClose"
                >
                  <i class="fa fa-archive"></i>
                  <span>{{ close }}</span>
                </button>-->
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarcodeReader from "@/components/BarcodeReader.vue";
import Select2 from "@/components/Select2.vue";

export default {
  name: "adminPickingReadingSixten",
  components: {
    BarcodeReader,
    Select2
  },
  data() {
    return {
      admin: dictionaryHelpers.getDictionary("Admin"),
      addPackage: dictionaryHelpers.getDictionary("AddPackage"),
      enableScanner: dictionaryHelpers.getDictionary("EnableScanner"),
      barcodeReaderData: "",
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      close: dictionaryHelpers.getDictionary("Close"),
      confirmAddPackage: dictionaryHelpers.getDictionary("ConfirmAddPackage"),
      confirmCancel: dictionaryHelpers.getDictionary("ConfirmCancel"),
      confirmClose: dictionaryHelpers.getDictionary("ConfirmClose"),
      confirmSave: dictionaryHelpers.getDictionary("ConfirmSave"),
      disableScanner: dictionaryHelpers.getDictionary("DisableScanner"),
      documentCode: "",
      hOrderPicking: 0,
      idFrmAdminPickingReading: "frmAdminPickingReading",
      idFrmBarcodeReader: "frmBarcodeReader",
      item: dictionaryHelpers.getDictionary("Item"),
      itemAlreadyPicked: dictionaryHelpers.getDictionary("ItemAlreadyPicked"),
      item_code: "",
      item_description: "",
      label_order_quantity: dictionaryHelpers.getDictionary("OrderQuantity"),
      label_order_picking: dictionaryHelpers.getDictionary("OrderPicking"),
      label_package: dictionaryHelpers.getDictionary("Package"),
      manualInput: true,
      order: dictionaryHelpers.getDictionary("Order"),
      order_quantity: 0,
      packageData: [],
      packageDataDefault: {},
      picking: dictionaryHelpers.getDictionary("Picking"),
      quantityPickedMoreThatQuantityOrder: dictionaryHelpers.getDictionary(
        "QuantityPickedMoreThatQuantityOrder"
      ),
      reading: dictionaryHelpers.getDictionary("Reading"),
      read: dictionaryHelpers.getDictionary("Read"),
      startReading: dictionaryHelpers.getDictionary("StartReading"),
      save: dictionaryHelpers.getDictionary("Save"),
      idSPackage: "sPackage",
      txtOrderPicking: 0,
      url: window.location.pathname,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted")
    };
  },
  watch: {
    barcodeReaderData: function(newVal, oldVal) {
      spinnerHelpers.show();
      var adminPickingReadingSixten = this;
      this.order_quantity = 0;
      this.txtOrderPicking = 0;

      if (functionHelpers.isValued(newVal)) {
        packageServices.getMaxByErp(newVal, this.$route.params, function(
          result
        ) {
          if (functionHelpers.isValued(result.data)) {
            adminPickingReadingSixten.packageDataDefault = {
              id: result.data.id,
              text: result.data.description
            };
          } else {
            adminPickingReadingSixten.executeAddPackage();
          }
        });

        documentRowServices.getByErp(newVal, this.$route.params, function(
          result
        ) {
          if (functionHelpers.isValued(result)) {
            adminPickingReadingSixten.order_quantity = result.data.quantity;

            if (functionHelpers.isValued(result.data.pickedQuantity)) {
              adminPickingReadingSixten.txtOrderPicking =
                result.data.quantity - result.data.pickedQuantity;
            } else {
              adminPickingReadingSixten.txtOrderPicking = result.data.quantity;
            }
            adminPickingReadingSixten.hOrderPicking =
              adminPickingReadingSixten.txtOrderPicking;

            adminPickingReadingSixten.item_code = result.data.itemCode;
            adminPickingReadingSixten.item_description =
              result.data.itemDescription;
            adminPickingReadingSixten.documentCode = result.data.documentCode;

            if (adminPickingReadingSixten.hOrderPicking <= 0) {
              notificationHelpers.error(
                adminPickingReadingSixten.itemAlreadyPicked
              );
            }
          }
          spinnerHelpers.hide();
        });

        this.$router.push({
          path: `/admin/picking/reading/${this.barcodeReaderData}`
        });
      } else {
        spinnerHelpers.hide();
      }
    },
    $route(to, from) {
      if (!functionHelpers.isValued(to.params.id)) {
        this.barcodeReaderData = "";
      }
    }
  },
  mounted() {
    this.$refs.txtBarcodeReader.focus();
    validationHelpers.validateBase($("#" + this.idFrmBarcodeReader));
    validationHelpers.validateBase($("#" + this.idFrmAdminPickingReading));
  },
  methods: {
    /*** READING ***/

    clickDisableScanner() {
      var adminPickingReadingSixten = this;
      this.manualInput = true;
      setTimeout(function() {
        adminPickingReadingSixten.$refs.txtBarcodeReader.focus();
      }, 500);
    },
    clickEnableScanner() {
      this.manualInput = false;
    },
    submitBarcode() {
      if (validationHelpers.isValid($("#" + this.idFrmBarcodeReader))) {
        this.barcodeReaderData = this.$refs.txtBarcodeReader.value;
      }
    },

    /*** END READING   ***/

    changeOrderPicking() {
      if (
        this.txtOrderPicking > this.order_quantity ||
        this.txtOrderPicking > this.hOrderPicking
      ) {
        notificationHelpers.error(this.quantityPickedMoreThatQuantityOrder);
      }
    },
    executeConfirmAddPackage() {
      if (confirm(this.confirmAddPackage)) {
        this.executeAddPackage();
      }
    },
    executeAddPackage() {
      spinnerHelpers.show();
      var adminPickingReadingSixten = this;
      packageServices.createByErp(
        this.barcodeReaderData,
        null,
        this.$route.params,
        function(result) {
          adminPickingReadingSixten.packageDataDefault = {
            id: result.data.id,
            text: result.data.description
          };
          spinnerHelpers.hide();
        }
      );
    },
    executeConfirmCancel() {
      if (confirm(this.confirmCancel)) {
        this.executeCancel();
      }
    },
    executeCancel() {
      spinnerHelpers.show();
      this.$router.push({
        path: `/admin/picking/reading`
      });
      spinnerHelpers.hide();
    },
    executeSave() {
      spinnerHelpers.show();
      var adminPickingReadingSixten = this;

      documentRowServices.insertBeforeDDT(
        this.barcodeReaderData,
        this.txtOrderPicking,
        $("#" + this.idSPackage).val(),
        this.$route.params,
        function(result) {
          notificationHelpers.success(
            adminPickingReadingSixten.updateCompleted
          );
          adminPickingReadingSixten.$router.push({
            path: `/admin/picking/reading`
          });
          spinnerHelpers.hide();
        }
      );
    }
    // executeConfirmClose() {
    //   if (confirm(this.confirmClose)) {
    //     this.executeClose();
    //   }
    // },
    // executeClose() {
    //   spinnerHelpers.show();
    //   notificationHelpers.success(this.updateCompleted);
    //   this.barcodeReaderData = "";
    //   spinnerHelpers.hide();
    // }
  }
};
</script>

<style>
hr {
  color: #f0f3f5;
}
</style>
